export const Breakpoints = {
  MOBILE: 480,
  TABLET: 768,
  DESKTOP: 960,
  WIDESCREEN: 1024,
};
